<template>
  <div class="custom-transfer-wrap">
    <CustomTransferTable
      transferDirection="left"
      :data-source="leftTableData"
      :tableLoading="transferTableLoading"
      @selectedKeys="updateSourceSelectedKeys"
    ></CustomTransferTable>
    <div class="transfer-btns">
      <a-button
        :disabled="!sourceSelectedRowKeys.length"
        size="small"
        type="primary"
        @click="divideTableData('toRight')"
        ><a-icon type="right" />
      </a-button>
      <a-button
        :disabled="!targetSelectedRowKeys.length"
        size="small"
        type="primary"
        @click="divideTableData('toLeft')"
      >
        <a-icon type="left"
      /></a-button>
    </div>
    <CustomTransferTable
      transferDirection="right"
      :data-source="rightTableData"
      :tableLoading="transferTableLoading"
      @selectedKeys="updateTargetSelectedKeys"
    ></CustomTransferTable>
  </div>
</template>

<script>
import CustomTransferTable from "./customTransferTable.vue";
export default {
  components: {
    CustomTransferTable
  },
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    transferTableLoading: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      leftTableData: [],
      rightTableData: [],
      sourceSelectedRowKeys: [],
      targetSelectedRowKeys: [],
      tableColumns: [
        {
          title: "Mac",
          key: "devId",
          dataIndex: "devId",
          ellipsis: true,
          width: 120,
          fixed: "left",
          customRender: text => text || "--"
        },
        {
          title: "点位名称",
          key: "deviceName",
          dataIndex: "deviceName",
          width: 120,
          customRender: text => text || "--"
        }
      ]
    };
  },
  computed: {
    listLength() {
      return this.dataSource.length || 0;
    }
  },
  watch: {
    listLength(val) {
      if (val > 0) {
        this.divideTableData();
      }
    }
  },
  methods: {
    updateSourceSelectedKeys(selectedRowKeys) {
      this.sourceSelectedRowKeys = selectedRowKeys;
    },
    updateTargetSelectedKeys(selectedRowKeys) {
      this.targetSelectedRowKeys = selectedRowKeys;
    },
    // 遍历源数据 selectFlag【true: 为右侧穿梭框数据】 checked【是否勾选】
    divideTableData(direction) {
      this.$emit("update:transferTableLoading", true);
      let tempDataSource = this.dataSource,
        tempLeftTableData = [],
        tempRightTableData = [],
        listLength = tempDataSource.length;
      for (let i = listLength - 1; i >= 0; i--) {
        let tempSelectFlag = !!tempDataSource[i].selectFlag;
        let tempChecked = !!tempDataSource[i].checked;
        if (direction === "toRight") {
          if (
            tempSelectFlag === true ||
            (tempSelectFlag === false && tempChecked)
          ) {
            if (tempSelectFlag === false && tempChecked) {
              // 左侧勾选数据取消勾选
              tempDataSource[i].checked = false;
              // 左侧勾选数据右置
              tempDataSource[i].selectFlag = true;
            }
            tempRightTableData.push(tempDataSource[i]);
          } else {
            tempLeftTableData.push(tempDataSource[i]);
          }
        } else if (direction === "toLeft") {
          if (
            tempSelectFlag === false ||
            (tempSelectFlag === true && tempChecked)
          ) {
            if (tempSelectFlag === true && tempChecked) {
              // 右侧勾选数据取消勾选
              tempDataSource[i].checked = false;
              // 右侧勾选数据左置
              tempDataSource[i].selectFlag = false;
            }
            tempLeftTableData.push(tempDataSource[i]);
          } else {
            tempRightTableData.push(tempDataSource[i]);
          }
        } else {
          if (tempSelectFlag === true) {
            tempRightTableData.push(tempDataSource[i]);
          } else {
            tempLeftTableData.push(tempDataSource[i]);
          }
        }
      }
      this.leftTableData = tempLeftTableData;
      this.rightTableData = tempRightTableData;
      this.$emit("update:transferTableLoading", false);
    }
  }
};
</script>

<style scoped lang="scss">
.custom-transfer-wrap {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .transfer-btns {
    display: flex;
    align-self: center;
    flex-flow: column nowrap;
    align-items: center;
    margin: 0 8px;
    .ant-btn-sm {
      width: 24px;
      height: 24px;
      padding: 0;
      font-size: 14px;
      border-radius: 4px;
    }
    .ant-btn:first-child {
      margin-bottom: 4px;
    }
  }
}
</style>
